import React, { useState, useEffect } from "react";
import { MdArrowBack, MdDescription } from "react-icons/md"; // Import file icon
import { useNavigate } from "react-router-dom";
import { createEmployee, getallRole, UpdateEmployeebyId } from "../../../api/api";
import toast from "react-hot-toast";
import { XMarkIcon } from '@heroicons/react/24/outline'; // Import close icon

const AddEmployee = ({ onBack, isView, isEdit, employee }) => {
  const [employeeData, setEmployeeData] = useState(
    employee || {
      name: "",
      contactNo: "",
      email: "",
      joiningDate: "",
      doc: "",
      uploaddoc: null,
      role: "",
      designation: "",
    }
  );
  const [error, setError] = useState("");
  const [designation, setDesignation] = useState("");
  const [isPreviewOpen, setIsPreviewOpen] = useState(false); // State for modal
  const [previewDoc, setPreviewDoc] = useState(""); // State for document URL
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEmployeeData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    getallRole().then((data) => {
      setDesignation(data.data);
    });
  }, []);

  // Handle file upload and store file name
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEmployeeData((prevData) => ({
        ...prevData,
        uploaddoc: file
      }));
      setPreviewDoc(URL.createObjectURL(file)); // Create a preview URL for the file
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let res;

      if (isEdit) {
        res = await UpdateEmployeebyId(employee._id, employeeData);
      } else {
        res = await createEmployee(employeeData);
      }

      setEmployeeData({
        name: "",
        contactNo: "",
        email: "",
        joiningDate: "",
        doc: "",
        uploaddoc: null,
        role: "",
        designation: "",
      });

      toast.success(res.message);
      onBack();
    } catch (error) {
      setError("An error occurred during signup.");
      toast.error(error.response?.data?.message);
    }
  };
  const handleDocClick = () => {
    setIsPreviewOpen(true); // Open the document preview modal
  };

  const handleClosePreview = () => {
    setIsPreviewOpen(false); // Close the document preview modal
  };

  return (
<div className="max-w-4xl mx-auto mt-3 p-4 poppins-medium">
  <div className="flex items-center mb-4">
    <MdArrowBack className="text-xl cursor-pointer mr-2" onClick={onBack} />
    <h1 className="text-xl font-semibold">
      {!employee ? "Add Employee" : isEdit ? "Edit Employee" : "View Employee"}
    </h1>     
  </div>

  {error && <div className="mb-4 text-red-500">{error}</div>}

  <form
    onSubmit={handleSubmit}
    className=" grid sm:grid-cols-1 md:grid-cols-3  gap-6"
  >
    {/* Name */}
    <div>
      <label className="block text-sm font-medium text-gray-700">
        Name<span className="text-red-500">*</span>
      </label>
      <input
        type="text"
        name="name"
        value={employeeData.name}
        disabled={isView}
        onChange={handleInputChange}
        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-black focus:border-black"
        placeholder="Enter Name"
        required
      />
    </div>

    {/* Contact Number */}
    <div>
      <label className="block text-sm font-medium text-gray-700">
        Contact Number<span className="text-red-500">*</span>
      </label>
      <input
        type="number"
        name="contactNo"
        value={employeeData.contactNo}
        disabled={isView}
        onChange={handleInputChange}
        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-black focus:border-black"
        placeholder="Enter mobile number"
        required
      />
    </div>

    {/* Email */}
    <div>
      <label className="block text-sm font-medium text-gray-700">
        Email<span className="text-red-500">*</span>
      </label>
      <input
        type="email"
        name="email"
        value={employeeData.email}
        disabled={isView}
        onChange={handleInputChange}
        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-black focus:border-black"
        placeholder="Enter email address"
        required
      />
    </div>

    {/* Role */}
    <div>
      <label className="block text-sm font-medium text-gray-700">
        Role<span className="text-red-500">*</span>
      </label>
      <select
        name="role"
        value={employeeData.role}
        disabled={isView}
        onChange={handleInputChange}
        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-black focus:border-black"
        required
      >
        <option value="" disabled>
          Select Role
        </option>
        <option value="super-admin">Super Admin</option>
        <option value="admin">Admin</option>
        <option value="employee">Employee</option>
      </select>
    </div>

    {/* Designation */}
    <div>
      <label className="block text-sm font-medium text-gray-700">
        Designation<span className="text-red-500">*</span>
      </label>
      <select
        name="designation"
        disabled={isView}
        value={employeeData.designation}
        onChange={handleInputChange}
        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-black focus:border-black"
        required
      >
        <option value="" disabled>
          Select Designation
        </option>
        {designation &&
          designation.map((d) => (
            <option key={d._id} value={d._id}>
              {d.role}
            </option>
          ))}
      </select>
    </div>

    {/* Joining Date */}
    <div>
      <label className="block text-sm font-medium text-gray-700">
        Joining Date<span className="text-red-500">*</span>
      </label>
      <input
        type="date"
        name="joiningDate"
        disabled={isView}
        value={employeeData.joiningDate.slice(0, 10)}
        onChange={handleInputChange}
        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-black focus:border-black"
        required
      />
    </div>

    {/* Select Document */}
    <div>
      <label className="block text-sm font-medium text-gray-700">
        Select Document<span className="text-red-500">*</span>
      </label>
      <select
        name="doc"
        value={employeeData.doc}
        disabled={isView}
        onChange={handleInputChange}
        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-black focus:border-black"
        required
      >
        <option value="" disabled>
          Select Document
        </option>
        <option value="aadhar">Aadhar Card</option>
        <option value="pan card">Pan Card</option>
      </select>
    </div>

    {/* Upload Document */}
    {!isView && (
      <div>
        <label className="block text-sm font-medium text-gray-700">
          Upload Document<span className="text-red-500">*</span>
        </label>
        <input
          type="file"
          accept="application/pdf"
          onChange={handleFileUpload}
          disabled={isView}
          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-black focus:border-black"
          required={!isEdit}
        />
      </div>
    )}

    {/* Uploaded Document Icon */}
    {employeeData.uploaddoc && (
      <div className="flex items-center cursor-pointer" onClick={handleDocClick}>
        <MdDescription className="h-8 w-8 text-gray-600 mr-2" />
        <span>{employeeData.uploaddoc?.name}</span>
      </div>
    )}

    {employee && (
      <div>
        <p className="font-medium">View Document</p>
        <p className="text-blue-500 cursor-pointer" onClick={() => setIsPreviewOpen(true)}>
          {employee.doc}.pdf
        </p>
      </div>
    )}

    {/* Submit Button */}
    <div className="col-span-1 sm:col-span-2 lg:col-span-3 mt-6 text-center">
      <button
        type="submit"
        disabled={isView}
        className="w-full bg-black text-white px-4 py-2 rounded-md shadow-sm focus:ring-black focus:border-black"
      >
        Submit
      </button>
    </div>
  </form>

  {/* Document Preview Modal */}
  {isPreviewOpen && (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="relative bg-white p-4 rounded-lg max-w-lg w-full">
        <button
          onClick={handleClosePreview}
          className="absolute top-2 right-2 text-black hover:text-gray-600"
        >
          <XMarkIcon className="w-6 h-6" />
        </button>
        <iframe
          src={previewDoc || employee.uploadDoc}
          title="Document Preview"
          className="w-full h-[80vh]"
          frameBorder="0"
        />
      </div>
    </div>
  )}
</div>

  

  );
};

export default AddEmployee;
